import { Box, Divider, Text } from '@factorialco/deprecated-design-system'
import { TimesheetPageShiftFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import AttendanceShiftUtils from 'modules/attendance/lib/utils/AttendanceShift'

interface Props {
  shifts: TimesheetPageShiftFragment[]
}

const WorkLocation = ({ shifts }: Props) => {
  if (!shifts.length) return null

  const locationTypesWithPercentage = AttendanceShiftUtils.totalMinutesPerLocationPercentage(shifts)
  const sortedEntries = Object.entries(locationTypesWithPercentage).sort(
    ([, aPercentage], [, bPercentage]) => parseFloat(bPercentage) - parseFloat(aPercentage)
  )

  return (
    <Box gap="s16">
      <Box paddingTop="s16">
        <Divider />
      </Box>
      <Box paddingTop="s16">
        <Text.Normal color="grey1000" weight="semibold">
          {i18n.t('clock_in.sidepanel.clocked.work_location.title')}
        </Text.Normal>
      </Box>
      <Box gap="s8">
        {sortedEntries.map(([label, percentage]) => (
          <Box key={label} justifyContent="spaceBetween" flexDirection="row" gap="s8">
            <Text.Normal color="grey800" size="100" weight="bold">
              {label.toUpperCase()}
            </Text.Normal>
            <Text.Normal weight="medium" color="grey1000">
              {percentage}
            </Text.Normal>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default WorkLocation
